<template>
  <div class="content-table-breadcrumbs">
    <el-breadcrumb
      v-if="isVisible"
      :max-items="4"
      class="my-16">
      <el-breadcrumb-item
        v-for="item in breadcrumbItems"
        :key="item.path"
        @click.native="handleBreadcrumbItemClick(item)">
        {{ item.crumbTitle }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { PENDING_STATUS } from '../store/action-status';

const { mapGetters } = createNamespacedHelpers('wre-dashboard');

export default {
  name: 'ContentTableBreadcrumbs',
  props: {
    menuItemId: {
      type: String,
      default: '',
      required: true
    },
    menuItemDisplayName: {
      type: String,
      default: '',
      required: true
    },
    subAccountId: {
      type: Number,
      default: 0,
      required: true
    },
    machineDisplayName: {
      type: String,
      default: '',
      required: true
    },
    archiveId: {
      type: String,
      default: '',
      required: true
    },
    archiveDisplayName: {
      type: String,
      default: '',
      required: true
    },
    isVisible: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  data() {
    return {
      breadcrumbItems: [{
        crumbTitle: '',
        path: ''
      }]
    };
  },
  computed: {
    ...mapGetters([
      'getActiveFolderItem',
      'getActiveVolumeSbSubAccountId',
      'getActiveVolumeSubscription',
      'getFetchSubAccountArchivesStatus'
    ])
  },
  watch: {
    getActiveVolumeSbSubAccountId(subAccountId) {
      if (subAccountId > 0 && this.getActiveVolumeSubscription === true) {
        this.updateBreadcrumbs({
          path: '',
          subAccountId: subAccountId
        });
      }
    },
    getFetchSubAccountArchivesStatus(status) {
      if (this.getActiveVolumeSubscription === true && status === PENDING_STATUS) {
        this.updateBreadcrumbs({
          path: '',
          subAccountId: this.subAccountId
        });
      }
    },
    getActiveFolderItem(activeFolderItem) {
      this.updateBreadcrumbs(activeFolderItem);
    }
  },
  methods: {
    updateBreadcrumbs(activeFolderItem) {
      if (activeFolderItem.path === '') {
        this.addPathRootCrumbs(activeFolderItem);
      } else {
        const crumbIdx = this.breadcrumbItems
          .findIndex(item => item.path === activeFolderItem.path);

        if (crumbIdx === -1) {
          const latestCrumbs = this.breadcrumbItems[this.breadcrumbItems.length - 1];
          if (latestCrumbs && latestCrumbs.isSearchFolder === true) {
            this.processCrumbsAfterSearch(activeFolderItem);
          } else {
            this.addCrumb(activeFolderItem);
          }
        } else {
          this.breadcrumbItems = this.breadcrumbItems.slice(0, crumbIdx + 1);
          if (activeFolderItem.isSearchFolder) {
            this.addCrumb(activeFolderItem);
          }
        }
      }
    },
    addCrumb(activeFolderItem) {
      this.breadcrumbItems.push({
        crumbTitle: activeFolderItem.displayName,
        archiveId: this.archiveId,
        path: activeFolderItem.path,
        isSearchFolder: activeFolderItem.isSearchFolder
      });
    },
    addPathRootCrumbs(activeFolderItem) {
      this.breadcrumbItems = [];

      this.breadcrumbItems.push({
        crumbTitle: this.menuItemDisplayName,
        menuItem: { id: this.menuItemId },
        path: `${this.menuItemId}.917c14f1-43cc-4346-89eb-c8b2b155feeb`,
        isSearchFolder: false
      });

      if (this.getActiveVolumeSubscription === true) {
        this.breadcrumbItems.push({
          crumbTitle: this.machineDisplayName,
          subAccountId: this.subAccountId,
          path: `${this.subAccountId}.118c14f1-43cc-4346-89eb-c8b2b155feeb`,
          isSearchFolder: false
        });
      }

      if (this.archiveId !== undefined && this.archiveId !== '') {
        this.breadcrumbItems.push({
          crumbTitle: this.archiveDisplayName,
          archiveId: this.archiveId,
          path: '',
          isSearchFolder: false
        });
      }

      if (activeFolderItem.isSearchFolder) {
        this.addCrumb(activeFolderItem);
      }
    },
    processCrumbsAfterSearch(activeFolderItem) {
      this.addPathRootCrumbs(activeFolderItem);
      if (activeFolderItem.path !== '') {
        const pathDelimiter = this.getPathDelimiter(activeFolderItem.path);

        let itemPath = activeFolderItem.path;
        let lastIdx = itemPath.lastIndexOf(pathDelimiter);

        const crumbsArray = [];

        while (lastIdx !== -1) {
          const displayName = itemPath.substring(lastIdx + 1);
          crumbsArray.push({
            crumbTitle: displayName,
            archiveId: this.archiveId,
            path: itemPath,
            isSearchFolder: false
          });

          itemPath = itemPath.substring(0, lastIdx);
          lastIdx = itemPath.lastIndexOf(pathDelimiter);

          if (lastIdx === -1 && itemPath !== '') {
            crumbsArray.push({
              crumbTitle: itemPath,
              archiveId: this.archiveId,
              path: itemPath,
              isSearchFolder: false
            });
          }
        }
        const resultCrumbs = crumbsArray.reverse();
        resultCrumbs.forEach(element => this.breadcrumbItems.push(element));
      }
    },
    getPathDelimiter(path) {
      const forwardSlashIdx = path.lastIndexOf('/');
      const backSlashIdx = path.lastIndexOf('\\');

      if (backSlashIdx > forwardSlashIdx) {
        return '\\';
      }
      return '/';
    },
    handleBreadcrumbItemClick(breadcrumbItem) {
      this.$emit('breadcrumbItemClick', breadcrumbItem);
    }
  }

};
</script>

<style lang="scss" scoped>

</style>
